import cn from '@/lib/cs';
import React from 'react';

const QuestionMarkIcon = ({
	className,
	...props
}: React.SVGProps<SVGSVGElement>) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		fill="none"
		viewBox="0 0 24 24"
		aria-hidden
		className={cn('h-8 lg:h-12 pointer-events-none', className)}
		{...props}
	>
		<g clipPath="url(#a)">
			<path
				fill="currentColor"
				d="M20 10.3c0 .3-.1.6-.4.9l-.8 1c-1 1-2.7 1.9-4 2.3l-4 .8-1.8.2c-1 0-.6-2.6-.6-3.1 0-.3 0-.4.3-.4l4.6-1.4.4-.3c.4-.6 1.2-1.4 1.1-2.2 1-2.5 1.6-3-2.2-3.7-1.9-1-2.5 2.1-2.8 3 0 .2 0 .3-.2.5h-.8l-2-.2L5 7.6a2 2 0 0 0-.8 0c-.1 0-.2 0-.2-.2v-.1c.4-2.4 1-3.6 2.5-5.5l.3-.2 1.9-1c1.8-1 5-.4 7-.3.2 0 .5 0 .6.2l1.9 1.3c.6.3 1 .8 1.6 1.2 2 1.9.8 5.2.3 7.3Zm-5.3 9 .5 1.2v.4l-.5 1.8c0 .1-.2.3-.4.3l-2.1 1h-.8c-1-.2-1.9-.5-2.9-.6-1-1-1.3-2-1-3.7 0-.7 1.2-1.1 1.7-1.4.3-.2.6-.3 1-.3 1 0 3.2-.3 4 .4.2.3.4.5.5.9Z"
			/>
		</g>
		<defs>
			<clipPath id="a">
				<path fill="currentColor" d="M0 0h24v24H0z" />
			</clipPath>
		</defs>
	</svg>
);

export default QuestionMarkIcon;
